import React, { useState, useEffect } from "react";
// import "../css/Blog.css";
import NAV from "./nav";
import Carousel from "./carousel";
import {contact, fetchBlog} from "../api";
import PriceScroller from "../components/pricescroll";
import {getCookie} from "../resources/utilities";

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = await contact(formData)
      if (data.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', message: '' });
      } else {
        alert('Failed to send message. Please try again later.');
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('An error occurred while sending your message.');
    }
  };

  return (
    <div>
          {/*<!-- Navbar & Hero Start -->*/}
        <div class="container-fluid position-relative p-0">
            <NAV activetag="contact"/>
            {/*<!-- Header Start -->*/}
            <div class="container-fluid bg-breadcrumb">
                {/*<div class="container text-center py-5" style={{maxwidth: '500px'}}>*/}
                <div className="container text-center py-2" style={{maxwidth: '500px', maxHeight: '100px'}}>
                    <h4 class="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Orion Analytics </h4>
                    {/*<ol class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">*/}
                    {/*    <li class="breadcrumb-item"><a href="index1.html">Home</a></li>*/}
                    {/*    <li class="breadcrumb-item"><a href="#">Pages</a></li>*/}
                    {/*    <li class="breadcrumb-item active text-primary">Service</li>*/}
                    {/*</ol>*/}
                </div>
            </div>
        </div>
            {/*<!-- Header End -->*/}
        {/*<!-- Navbar & Hero End -->*/}
      {/* 2-Column Layout */}
      <div style={styles.wrapper}>
        {/* Left: Address + Map */}
        <div style={styles.left}>
          <h2 style={styles.subHeading}>Our Office</h2>
          <p><strong>Address:</strong><br /> MIG 2/232, Kalinga Vihar, Chennd,<br /> Rourkela, Odisha, India - 769015</p>
          <p><strong>Phone:</strong> +91 98616 15950</p>
          <div style={{ marginTop: '1rem' }}>
            <iframe
              title="Orion Analytics Office"
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d274.4695879531581!2d84.81023746834282!3d22.24736695627606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDE0JzUwLjYiTiA4NMKwNDgnMzYuNiJF!5e0!3m2!1sen!2sin!4v1744129102976!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Right: Contact Form */}
        <div style={styles.right}>
          <h1 style={styles.heading}>Contact Us</h1>
          {submitted ? (
            <p style={styles.successMessage}>Thank you! We'll get back to you soon.</p>
          ) : (
            <form onSubmit={handleSubmit} style={styles.form}>
              <input required type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" style={styles.input} />
              <input required type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" style={styles.input} />
              <textarea required name="message" value={formData.message} onChange={handleChange} placeholder="Your Message" style={styles.textarea} rows={5} />
              <button
                type="submit"
                style={styles.button}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.button.backgroundColor}
              >
                Send
              </button>
            </form>
          )}
          <p style={styles.emailText}>
            Or simply email us at <a href="mailto:info@orionics.in" style={styles.emailLink}>info@orionics.in</a>
          </p>
        </div>
      </div>
  </div>
  );
};
const styles = {
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "5rem",
    padding: "2rem 1rem",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  left: {
    flex: "1 1 45%",
    minWidth: "300px",
    fontSize: "1rem",
    color: "#1F2937",
  },
  right: {
    flex: "1 1 45%",
    minWidth: "300px",
  },
  heading: {
    fontSize: "1.5rem",
    fontWeight: "700",
    marginBottom: "1rem",
    color: "#1F2937",
  },
  subHeading: {
    fontSize: "1.25rem",
    fontWeight: "600",
    marginBottom: "0.75rem",
  },
  successMessage: {
    color: "#16A34A",
    fontWeight: "500",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  input: {
    width: "100%",
    padding: "0.5rem",
    border: "1px solid #D1D5DB",
    borderRadius: "0.375rem",
  },
  textarea: {
    width: "100%",
    padding: "0.5rem",
    border: "1px solid #D1D5DB",
    borderRadius: "0.375rem",
  },
  button: {
    backgroundColor: "#2563EB",
    color: "#FFFFFF",
    padding: "0.5rem 1rem",
    borderRadius: "0.375rem",
    border: "none",
    cursor: "pointer",
  },
  buttonHover: {
    backgroundColor: "#1D4ED8",
  },
  emailText: {
    marginTop: "1.5rem",
    fontSize: "0.875rem",
    color: "#4B5563",
  },
  emailLink: {
    color: "#2563EB",
    textDecoration: "underline",
  },
};
export default Contact;
